// extracted by mini-css-extract-plugin
export default {"main":"Contact_main__dbmnd","contactMessage":"Contact_contactMessage__4u4VI","light":"Contact_light__I2yHv","dark":"Contact_dark__PuK9X"};